import * as React from 'react'
import { Route, withRouter } from 'react-router-dom'
import { Redirect, RouteComponentProps, RouteProps } from 'react-router'
import { isUserAuthenticated } from '$services/session/isAuthenticated/isAuthenticated.service'
import { saveRedirectPath } from '$services/session/redirectPath/redirectPath.service'
import { routeProvider } from '../../utils/routeProvider'

const PrivateRouteRaw: React.FC<RouteProps & RouteComponentProps<any>> = ({ ...props }) => {
  const isAuthenticated = isUserAuthenticated()

  if (isAuthenticated) {
    return <Route {...props} />
  }
  if (props.location.search) {
    saveRedirectPath(`${props.location.pathname}${props.location.search}`)
  } else {
    saveRedirectPath(props.location.pathname)
  }

  return <Redirect to={routeProvider.login} />
}

export const PrivateRoute = withRouter(PrivateRouteRaw)



// WEBPACK FOOTER //
// ./src/views/components/PrivateRoute.tsx